/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PaginasEspecificas from '../../../../components/paginasEspecificas';

function Evolucao() {
  return (
    <PaginasEspecificas posicao="22" endereco="/biologia" materia="Biologia" />
  );
}

export default Evolucao;
